// extracted by mini-css-extract-plugin
export default {"cancelButton":"ConfirmDialog_cancelButton__bS05N","confirmButton":"ConfirmDialog_confirmButton__EE-xO"};